import script from "./UnderstandingSection.vue?vue&type=script&setup=true&lang=js"
export * from "./UnderstandingSection.vue?vue&type=script&setup=true&lang=js"

import "./UnderstandingSection.vue?vue&type=style&index=0&id=919a0602&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-919a0602"]])

export default __exports__